/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { responsesPartMeta } from '../models/responsesPartMeta';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class SystemProcessesService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * initialize technical/custom roles and matrix for a company
   * @param companyUuid company unique identifier
   * @returns any Authorizations successfully initialized
   * @throws ApiError
   */
  public postApiServiceauthorizationProcessesSystemInitRolesPermissions(
    companyUuid: string,
  ): CancelablePromise<{
    data?: {
      done?: boolean;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/serviceauthorization/processes/system/init-roles-permissions/{companyUuid}',
      path: {
        'companyUuid': companyUuid,
      },
    });
  }

  /**
   * initialize technical/custom roles and matrix for an enterprise
   * @param enterpriseUuid enterprise unique identifier
   * @returns any Authorizations successfully initialized
   * @throws ApiError
   */
  public postApiServiceauthorizationProcessesSystemInitEnterpriseRolesPermissions(
    enterpriseUuid: string,
  ): CancelablePromise<{
    data?: {
      done?: boolean;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/serviceauthorization/processes/system/init-enterprise-roles-permissions/{enterpriseUuid}',
      path: {
        'enterpriseUuid': enterpriseUuid,
      },
    });
  }

}
